import { useId } from 'react'

interface Props {
  active?: boolean
  strokeColors?: [string, string]
  backgroundColor?: string
}

export function RewardFramePaid({
  active,
  strokeColors,
  backgroundColor,
}: Props) {
  const [strokeColor0, strokeColor1] = strokeColors ?? ['white', '#FF6984']
  const bgColor = backgroundColor ?? '#FF5776'
  const id = useId()
  const maskId = `mask${id}`
  const grad0Id = `grad0${id}`
  const grad1Id = `grad1${id}`

  return (
    <svg
      width="113"
      height="104"
      viewBox="0 0 113 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId} fill="white">
        <path d="M52.8 0C70.72 0 79.682 0 86.527 3.487a32 32 0 0 1 13.986 13.986c1.959 3.846 2.816 8.36 3.192 14.756.182 3.108.273 4.662.465 5.773.615 3.553 1.819 6.235 4.066 9.055.703.882 1.585 1.764 3.35 3.529a2 2 0 0 1 0 2.828c-1.764 1.764-2.646 2.646-3.348 3.527-2.249 2.82-3.453 5.504-4.068 9.059-.192 1.11-.283 2.663-.465 5.77-.375 6.396-1.233 10.91-3.192 14.757a32 32 0 0 1-13.986 13.986C79.682 104 70.721 104 52.8 104h-1.6c-17.921 0-26.882 0-33.727-3.487A32 32 0 0 1 3.487 86.527C0 79.682 0 70.721 0 52.8v-1.6C0 33.28 0 24.318 3.487 17.473A32 32 0 0 1 17.473 3.487C24.318 0 33.279 0 51.2 0z" />
      </mask>
      <path
        d="M52.8 0C70.72 0 79.682 0 86.527 3.487a32 32 0 0 1 13.986 13.986c1.959 3.846 2.816 8.36 3.192 14.756.182 3.108.273 4.662.465 5.773.615 3.553 1.819 6.235 4.066 9.055.703.882 1.585 1.764 3.35 3.529a2 2 0 0 1 0 2.828c-1.764 1.764-2.646 2.646-3.348 3.527-2.249 2.82-3.453 5.504-4.068 9.059-.192 1.11-.283 2.663-.465 5.77-.375 6.396-1.233 10.91-3.192 14.757a32 32 0 0 1-13.986 13.986C79.682 104 70.721 104 52.8 104h-1.6c-17.921 0-26.882 0-33.727-3.487A32 32 0 0 1 3.487 86.527C0 79.682 0 70.721 0 52.8v-1.6C0 33.28 0 24.318 3.487 17.473A32 32 0 0 1 17.473 3.487C24.318 0 33.279 0 51.2 0z"
        fill={`url(#${grad0Id})`}
        fillOpacity={active ? 0.8 : 0.4}
        style={{
          mixBlendMode: 'hard-light',
        }}
      />
      <path
        d="m86.527 3.487.908-1.782zm13.986 13.986 1.782-.908zm11.073 33.113L113 49.172zm0 2.828L113 54.828zm-11.073 33.113 1.782.908zm-13.986 13.986.908 1.782zm-69.054 0-.908 1.782zM3.487 86.527l-1.782.908zm0-69.054-1.782-.908zM17.473 3.487l-.908-1.782zm86.232 68.282 1.996.118zm.465-5.77-1.971-.34zm0-27.997-1.97.34zm4.066 9.055 1.564-1.247zM52.8 0v2c8.993 0 15.618.001 20.854.43 5.213.425 8.872 1.263 11.965 2.84l.908-1.783.908-1.782C83.684-.206 79.44-1.112 73.98-1.558 68.544-2.002 61.727-2 52.8-2zm33.727 3.487L85.62 5.27a30 30 0 0 1 13.112 13.112l1.782-.908 1.782-.908a34 34 0 0 0-14.86-14.86zm13.986 13.986-1.782.908c1.772 3.479 2.608 7.666 2.977 13.965l1.997-.117 1.996-.117c-.381-6.493-1.26-11.334-3.406-15.547zm11.073 33.113L110.172 52l1.414 1.414L113 54.828a4 4 0 0 0 0-5.656zm-7.881 21.183-1.997-.117c-.369 6.3-1.205 10.488-2.977 13.967l1.782.908 1.782.908c2.146-4.213 3.026-9.055 3.406-15.548zm-3.192 14.758-1.782-.908a30 30 0 0 1-13.112 13.112l.908 1.782.908 1.782a34 34 0 0 0 14.86-14.86zm-13.986 13.986-.908-1.782c-3.093 1.576-6.752 2.414-11.965 2.84-5.236.428-11.86.429-20.854.429v4c8.927 0 15.744.002 21.18-.442 5.46-.446 9.704-1.352 13.455-3.263zM52.8 104v-2h-1.6v4h1.6zm-1.6 0v-2c-8.993 0-15.619-.001-20.854-.429-5.213-.426-8.872-1.264-11.965-2.84l-.908 1.782-.908 1.782c3.751 1.911 7.995 2.817 13.455 3.263 5.436.444 12.253.442 21.18.442zm-33.727-3.487.908-1.782A30 30 0 0 1 5.269 85.619l-1.782.908-1.782.908a34 34 0 0 0 14.86 14.86zM3.487 86.527l1.782-.908c-1.576-3.093-2.414-6.752-2.84-11.965C2.001 68.418 2 61.794 2 52.8h-4c0 8.927-.002 15.744.442 21.18.446 5.46 1.352 9.704 3.263 13.455zM0 52.8h2v-1.6h-4v1.6zm0-1.6h2c0-8.993.001-15.619.43-20.854.425-5.213 1.263-8.872 2.84-11.965l-1.783-.908-1.782-.908C-.206 20.316-1.112 24.56-1.558 30.02-2.002 35.456-2 42.273-2 51.2zm3.487-33.727 1.782.908A30 30 0 0 1 18.381 5.269l-.908-1.782-.908-1.782a34 34 0 0 0-14.86 14.86zM17.473 3.487l.908 1.782c3.093-1.576 6.752-2.414 11.965-2.84C35.58 2.001 42.206 2 51.2 2v-4c-8.927 0-15.744-.002-21.18.442-5.46.446-9.704 1.352-13.455 3.263zM51.2 0v2h1.6v-4h-1.6zm60.386 53.414L110.172 52c-1.729 1.728-2.709 2.704-3.498 3.694l1.564 1.247 1.564 1.246c.615-.771 1.399-1.56 3.198-3.359zm-7.881 18.355 1.996.118c.187-3.172.272-4.578.44-5.547L104.17 66l-1.971-.341c-.216 1.251-.312 2.952-.491 5.993zm4.533-14.828-1.564-1.247c-2.458 3.084-3.803 6.08-4.475 9.965l1.971.34 1.971.341c.557-3.223 1.622-5.595 3.661-8.153zm-4.533-24.712-1.997.117c.179 3.043.275 4.744.492 5.997l1.97-.341 1.971-.341c-.167-.97-.253-2.376-.44-5.55zm7.881 18.357L113 49.172c-1.8-1.8-2.585-2.59-3.2-3.361l-1.564 1.246-1.564 1.246c.79.992 1.77 1.968 3.5 3.697zm-7.416-12.584-1.97.34c.671 3.885 2.015 6.878 4.472 9.961l1.564-1.246 1.564-1.247c-2.037-2.557-3.102-4.927-3.659-8.15z"
        fill={`url(#${grad1Id})`}
        mask={`url(#${maskId})`}
      />
      <defs>
        <linearGradient
          id={grad0Id}
          x1={active ? '61.352' : '61.424'}
          y1="0"
          x2={active ? '61.352' : '61.424'}
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={active ? 'white' : bgColor} stopOpacity="0.2" />
          <stop
            offset="0.7"
            stopColor={active ? 'white' : bgColor}
            stopOpacity="0.9"
          />
        </linearGradient>
        <linearGradient
          id={grad1Id}
          x1="53"
          y1="0"
          x2="51.5"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={strokeColor0} />
          <stop offset="1" stopColor={strokeColor1} />
        </linearGradient>
      </defs>
    </svg>
  )
}
